import React, { useState, useRef } from 'react'
import ReCAPTCHA from 'react-google-recaptcha'
import * as reCaptchaKey from './../../../shared/constants/reCaptcha'
import Loader from 'react-loader-spinner'

import { siteUrl } from '../../../shared/utils/siteUrl'
import imgModalLogin from '../../../assets/images/modal-login/banner_login.png'
import useMediaQuery from '../../../utils/useMediaQuery'
import userSessionStorage from '../../../utils/userSessionStorage'
import getUrlIdRegister from '../../../utils/getUrlIdRegister'
import pushEventDataLayer from '../../../utils/pushEventDataLayer'

import './modal-login.scss'

const ModalLogin = ({ close }) => {
  const [isLoading, setIsLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [data, setData] = useState({
    email: '',
    password: '',
  })
  const recaptchaRef = useRef(null)
  const session = new userSessionStorage()

  const isMobile = useMediaQuery()

  const handleInputChange = event => {
    setData({
      ...data,
      [event.target.name]: event.target.value,
    })
  }

  const handleErrorMessage = message => {
    setErrorMessage(message)
    setTimeout(() => {
      setErrorMessage('')
    }, 5000)
  }

  const onSubmit = event => {
    event.preventDefault()
    setIsLoading(true)
    session.authLogin({
      payload: {
        email: data.email ? data.email.replace(/\s+/g, '') : '',
        password: data.password,
        captcha: recaptchaRef.current.getValue(),
      },
      handleSuccess: res => {
        session.authUserInfo({
          handleSuccess: res => {
            setIsLoading(false)
            pushEventDataLayer(
              'Interacciones - Inicio sesión',
              'yogo-yogo',
              'click inicio sesion',
              'Enviar'
            )
            window.location.reload()
          },
          handleError: res => {
            session.destroySession()
            handleErrorMessage(res.userMessage)
            setIsLoading(false)
          },
        })
      },
      handleError: res => {
        handleErrorMessage(res.userMessage)
        setIsLoading(false)
      },
      handleFinally: () => {
        recaptchaRef.current.execute()
      },
    })
  }

  return (
    <div className="f-modalLogin-container">
      <ReCAPTCHA
        ref={recaptchaRef}
        size="invisible"
        sitekey={reCaptchaKey.key}
      />
      <div className="f-modalLogin-container__wrapper">
        <button
          className="f-modalLogin-container__wrapper__buttonClose"
          onClick={close}
        >
          X
        </button>
        <section className="f-modalLogin-container__infoLogin">
          <h2>INICIA SESIÓN</h2>
          <p>
            Si ya estás registrada en NosotrasOnline, ingresa tu usuario y
            contraseña.
          </p>
          <form onSubmit={onSubmit}>
            <label>Correo:</label>
            <input
              type="email"
              placeholder="correo@email.com"
              id="user"
              name="email"
              onChange={handleInputChange}
            />
            <label>Contraseña:</label>
            <input
              type="password"
              placeholder="*********"
              id="password"
              name="password"
              onChange={handleInputChange}
            />
            <a
              href={siteUrl + '/login/recuperar/'}
              className="f-olvide"
              target="_blank"
              onClick={() =>
                pushEventDataLayer(
                  'Interacciones - Inicio sesión',
                  'yogo-yogo',
                  'Olvidé mi contraseña',
                  'Enviar'
                )
              }
            >
              Olvidé mi contraseña
            </a>
            {errorMessage && (
              <span className="f-errorMessage">{errorMessage}</span>
            )}

            <div className="f-modalLogin-container__infoLogin__buttons">
              <button
                className="f-proDefense-button f-proDefense-button--loginButton"
                type="submit"
                disabled={isLoading}
              >
                {isLoading ? (
                  <Loader type="Oval" color="#ffffff" height={22} width={30} />
                ) : (
                  'Enviar'
                )}
              </button>
              <a
                href={siteUrl + getUrlIdRegister()}
                target="_blank"
                onClick={() =>
                  pushEventDataLayer(
                    'Interacciones - Inicio sesión',
                    'yogo-yogo',
                    'Quiero registrarme',
                    'Enviar'
                  )
                }
              >
                Quiero Registrarme
              </a>
            </div>
          </form>
        </section>
        {!isMobile && (
          <img src={imgModalLogin} alt="chicas reunidas en el login" />
        )}
      </div>
    </div>
  )
}

export default ModalLogin
